/**
 * A finger shaken (2026-10-24, Adam: an arrow is taken off its mark by shaking it): quick strokes
 * back and forth, each long enough and turning back along itself — three turns within a moment.
 * A slow slide this way and that, however long, is never one.
 */
const SHAKE_MIN = 26;
const SHAKE_BACK = 18;
const SHAKE_STROKE_MS = 380;
const SHAKE_WINDOW_MS = 950;
const SHAKE_TURNS = 3;
export class Shake {
  #anchor: { x: number; y: number; t: number } | null = null;
  #far: { x: number; y: number; t: number } | null = null;
  #turns: number[] = [];
  /** The finger here now (screen px, ms): true once it has been shaken. */
  add(x: number, y: number, t: number): boolean {
    const a = this.#anchor,
      e = this.#far;
    if (!a || !e) {
      this.#anchor = this.#far = { x, y, t };
      return false;
    }
    const len = Math.hypot(e.x - a.x, e.y - a.y);
    // the stroke goes on: further from where it began than it has been
    if (Math.hypot(x - a.x, y - a.y) >= len) {
      this.#far = { x, y, t };
      // (a long slow stroke is a slide, not a shake: it begins again from here)
      if (t - a.t > SHAKE_STROKE_MS) this.#anchor = this.#far = { x, y, t };
      return false;
    }
    const bx = x - e.x,
      by = y - e.y;
    const back = Math.hypot(bx, by);
    if (len >= SHAKE_MIN && back >= SHAKE_BACK && e.t - a.t <= SHAKE_STROKE_MS) {
      // back the way it came (not off to a side)
      const along = -(bx * (e.x - a.x) + by * (e.y - a.y)) / (len * back);
      if (along > 0.6) {
        this.#turns = [...this.#turns.filter((tt) => t - tt <= SHAKE_WINDOW_MS), t];
        this.#anchor = e;
        this.#far = { x, y, t };
        return this.#turns.length >= SHAKE_TURNS;
      }
    }
    if (t - a.t > SHAKE_STROKE_MS * 1.5) this.#anchor = this.#far = { x, y, t };
    return false;
  }
}
